import styled from 'styled-components';

import variables from '../../../styles/variables';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;
  margin: 0 auto;

  @media screen and (max-width: 1023px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }
`;

export const ContentLeft = styled.div`
  width: 40%;
  float: left;
  position: relative;

  @media screen and (max-width: 768px) {
    width: 100%;
    clear: both;
    position: relative;
  }
`;

export const ContentRight = styled.div`
  width: 60%;
  float: right;
  text-align: center;
  position: relative;
  background-size: 100%;
  background-position: center 15%;
  background-repeat: no-repeat;
  margin-bottom: -14rem;

  @media screen and (max-width: 768px) {
    width: 100%;
    clear: both;
    position: relative;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  position: relative;
  padding: 35% 0;

  @media screen and (max-width: 768px) {
    width: 100%;
    clear: both;
    position: relative;
    padding: 2rem 0;
    text-align: center;
  }
`;

export const Headline = styled.h1`
  color: ${variables.colorRed};
  font-size: 2.5rem;
  text-transform: none;
  line-height: 2.8125rem;
  margin-bottom: 0;
  width: 100%;
  clear: both;

  @media screen and (max-width: 768px) {
    font-size: 2rem;
    line-height: 2.6rem;
    margin-bottom: 0;
  }

  @media screen and (max-width: 480px) {
    font-size: 1.875rem;
    line-height: 2rem;
  }

  &.secondary {
    color: ${variables.colorBlack};
  }
`;

export const Link404 = styled.div`
  display: flex;
  width: 100%;
  margin: 0 auto;
  position: relative;
  clear: both;
  padding: 1rem 0 0;

  @media screen and (max-width: 768px) {
    text-align: center;
  }

  p {
    @media screen and (max-width: 768px) {
      text-align: center;
      width: 100%;
    }

    a {
      color: ${variables.colorRed};
      text-decoration: none;
      transition: all 200ms ease;

      &:hover,
      &:focus {
        color: ${variables.colorGrey};
      }
    }
  }
`;
